export default __webpack_public_path__ + "a0965ab462cabfb827190b1034e3da1b.svg";